import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordComponent } from './password/password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MenuService} from '../menu/menu.service';
import {RouterModule} from '@angular/router';
import {accountRoutes} from './account.routes';
const routing: ModuleWithProviders = RouterModule.forRoot(accountRoutes);
@NgModule({
  imports: [
    CommonModule,
      FormsModule,
      ReactiveFormsModule,
      routing
  ],
  declarations: [PasswordComponent]
})
export class AccountModule {
  constructor(private menuService: MenuService) {
      this.menuService.addMenuItems(
          [
              {
                  name: 'account',
                  path: '/account',
                  icon: 'fas fa-user-circle',
              }]);
  }
}



// WEBPACK FOOTER //
// ./src/app/account/account.module.ts